import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { FcCustomSelectComponent } from './fc-custom-select.component';


@NgModule({
  declarations: [
    FcCustomSelectComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    FormsModule
  ],
  exports: [
    FcCustomSelectComponent
  ]
})
export class FcCustomSelectModule { }
